import {
  Entity,
  PrimaryGeneratedColumn,
  Column,
  ManyToOne,
  Index,
  JoinColumn,
  CreateDateColumn,
  UpdateDateColumn,
  RelationId
} from 'typeorm'
import { ObjectType, Field, ID, Float } from 'type-graphql'
import { Domain, ScalarObject } from '@things-factory/shell'
import { KpiMetric } from '../kpi-metric/kpi-metric'
import { KpiPeriodType } from '../kpi/kpi'
import { User } from '@things-factory/auth-base'

@Entity()
@Index('ix_kpi_metric_value_latest', ['domain', 'metric', 'valueDate', 'org'], { unique: true })
@ObjectType({ description: 'Current value for each KPI metric (can be used for both state and history).' })
export class KpiMetricValue {
  @PrimaryGeneratedColumn('uuid')
  @Field(type => ID)
  id: string

  @ManyToOne(() => Domain)
  @Field(type => Domain, { nullable: true })
  domain?: Domain

  @RelationId((entity: KpiMetricValue) => entity.domain)
  @Field({ nullable: true })
  domainId?: string

  @ManyToOne(() => KpiMetric, { nullable: false, onDelete: 'CASCADE' })
  @JoinColumn({ name: 'metricId' })
  @Field(type => KpiMetric)
  metric: KpiMetric

  @RelationId((entity: KpiMetricValue) => entity.metric)
  @Field()
  metricId: string

  @Column('float')
  @Field(type => Float)
  value: number

  @Column({ nullable: true })
  @Field({ nullable: true })
  unit?: string

  @Column()
  @Field({
    description:
      'Date or period for which this metric value is recorded (e.g., day: YYYY-MM-DD, month: YYYY-MM, range: YYYY-MM-DD~YYYY-MM-DD).'
  })
  valueDate: string

  @Column({ default: 'DAY' })
  @Field(type => KpiPeriodType)
  periodType: KpiPeriodType

  @Column({ default: '' })
  @Field({ nullable: true, description: 'Organizational unit for this value (project, department, company, employee, etc.)' })
  org?: string

  @Column({ type: 'simple-json', nullable: true })
  @Field(type => ScalarObject, { nullable: true })
  meta?: any

  @CreateDateColumn()
  @Field({ nullable: true })
  createdAt?: Date

  @UpdateDateColumn()
  @Field({ nullable: true })
  updatedAt?: Date

  @ManyToOne(() => User, { nullable: true })
  @Field(type => User, { nullable: true })
  creator?: User

  @RelationId((entity: KpiMetricValue) => entity.creator)
  @Field({ nullable: true })
  creatorId?: string

  @ManyToOne(() => User, { nullable: true })
  @Field(type => User, { nullable: true })
  updater?: User

  @RelationId((entity: KpiMetricValue) => entity.updater)
  @Field({ nullable: true })
  updaterId?: string
}
